import { render, staticRenderFns } from "./ReviewInterMenu.vue?vue&type=template&id=93885b14&"
import script from "./ReviewInterMenu.vue?vue&type=script&lang=js&"
export * from "./ReviewInterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReviewInterMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports